import ButtonPrime from "@/components/navigation/ButtonPrime";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";

export default function VorteileSectionVermieten() {
  return (
    <div>
      <div className="max-w-[85rem] px-4 md:py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div className="py-10">
          {/* <h2 className='font-semibold text-dark-100 font-serif text-2xl'>Ihre Vorteile</h2> */}
          <div className="md:flex flex-wrap justify-between py-5 block">
            <div className="py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]">
              <img className="size-12 " src="/Icons/vermietung-vorteile-beratung-1.svg" alt="" />
              <h3 className="pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif">
                Persönliche Beratung
              </h3>
              <p className="text-dark-200 ">
              Wir nehmen uns Zeit für Ihre Fragen – vom ersten Gespräch bis zur Schlüsselübergabe.              </p>
            </div>
            <div className="py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]">
              <img className="size-12" src="/Icons/vermietung-vorteile-erfahrung-2.svg" alt="" />
              <h3 className="pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif">
              Lokaler Experte
              </h3>
              <p className="text-dark-200 ">
              Expertise seit 1978 - wir kennen den Markt und vermieten Ihre Immobilie zuverlässig.
              </p>
            </div>

            <div className="py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]">
              <img className="size-12" src="/Icons/vermietung-vorteile-bonität-3.svg" alt="" />
              <h3 className="pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif">
                Bonität geprüft
              </h3>
              <p className="text-dark-200 ">
              Damit Sie sich auf zuverlässige Mieter verlassen können – weil Sicherheit an erster Stelle steht.
              </p>
            </div>
            <div className="py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]">
              <img className="size-12" src="/Icons/vermietung-vorteile-rechtssicher-4.svg" alt="" />
              <h3 className="pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif">
              Rechtssichere Vermietung
              </h3>
              <p className="text-dark-200 ">
              Vom Mietvertrag bis zur Übergabe – wir sorgen für eine rechtlich saubere Abwicklung.
              </p>
            </div>
          </div>
          <Link to='/bewerten/formular/online-bewertung'>
                <ButtonPrime text='Kostenlose Immobilienbewertung' icon={<CalendarDateRangeIcon/>} className='w-full mx-auto md:w-fit md:mt-10 ' />
                </Link>
        </div>
      </div>
    </div>
  );
}
